'use client';

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { ChevronDown, ChevronUp } from 'lucide-react';

import { cn } from '@/shared/utils/cn';

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

const CollapsibleTriggerContainer = ({
  children,
  isExpanded,
  onClick,
  className,
}: {
  children: React.ReactNode;
  isExpanded: boolean;
  onClick?: () => void;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        'flex h-[36px] w-fit cursor-pointer flex-row items-center justify-center gap-1 rounded-[8px] border-[0.5px] border-[#d9d9d9] px-4 py-2.5 text-[13px] font-medium leading-normal text-white',
        className,
      )}
      onClick={onClick}
    >
      {children}
      {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
    </div>
  );
};

export {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
  CollapsibleTriggerContainer,
};
